export default __webpack_public_path__ + "static/5-artificial-intelligence-8729176067001195f8bdbc38affd060a.png";